/*
 * Copyright (c) 2024. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import { forwardRef } from 'react';
import { NumericFormat } from 'react-number-format';

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  'data-fixeddecimalscale'?: boolean;
  'data-decimalscale'?: number;
  'data-dollarvalue'?: 'true' | 'false';
}

export const TextFieldNumberFormatCustom = forwardRef<typeof NumericFormat<string>, CustomProps>(
  (props, ref) => {
    const { onChange, ...other } = props;

    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        thousandSeparator
        valueIsNumericString
        fixedDecimalScale={other['data-fixeddecimalscale'] ?? true}
        decimalScale={
          other['data-decimalscale'] ?? (other['data-dollarvalue'] === 'true' ? 2 : undefined)
        }
        prefix={other['data-dollarvalue'] === 'true' ? '$' : ''}
      />
    );
  },
);
